import React from 'react'

import { FormDensity } from './ui2-form.config'

/**
 * Form-level defaults a `ui2:form` publishes to its children via withUI2FormContext.
 * isReadOnly/isDisabled are enforced (override the child); the rest are overrideable defaults.
 */
export interface UI2FormContextProps {
  formDensity?: FormDensity
  /** Force-on overrides child. */
  isReadOnly?: boolean
  /** Force-on overrides child. */
  isDisabled?: boolean
  /** Form-level default for `isRequired`. Overrideable by child. */
  isRequired?: boolean
  /** Form-level default for `isOptional`. Overrideable by child. */
  isOptional?: boolean
  /** Form-level default for `isCollapsed`. Overrideable by child. */
  isCollapsed?: boolean
  /** Form-level default for `isCollapsable`. Overrideable by child. */
  isCollapsable?: boolean
  /** Form-level default for `isHorizontalLayout`. Overrideable by child. Desktop web only. */
  isHorizontalLayout?: boolean
  /** Form-level default for `enablePrefilledMode`. Overrideable by child. */
  enablePrefilledMode?: boolean
  /**
   * Explicit `null` suppresses descendant inlineHelpText (stacked completed sections).
   * Must stay type-compatible with UI2FormSectionConfigProps.inlineHelpText — withUI2FormContext's
   * generic inference silently falls back to this constraint type.
   */
  inlineHelpText?: string | string[] | null
  /**
   * Descendants drop their required-for-validation flag. Set by definitively-not-applicable
   * sections (rejected entryPredicate, or final step where remaining sections can't apply).
   */
  sectionIsNotApplicable?: boolean
}

export const UI2FormContext = React.createContext<UI2FormContextProps>({})
